import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineLite, TweenLite} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {TheCryptGameAssets} from "../TheCryptGameAssets";
import {TheCrypt} from "../TheCrypt";
import {TheCryptHelper} from "../utils/TheCryptHelper";
import {TheCryptSoundManager} from "../sound/TheCryptSoundManager";
import {TheCryptSoundConfig} from "../configs/TheCryptSoundConfig";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import Spine = PIXI.spine.Spine;
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class TheCryptWinCapView extends PIXI.Container implements StageLayer {
    private _spines: Spine | null;
    private _spineContainer: PIXI.Sprite;
    private _button: ContinueButton;
    private _clickCallback: () => void;
    private _idleTimeLine: TimelineLite | null;
    private _countUp: BasicBitmapCountUp;

    private init(): void {
        this._spineContainer = new PIXI.Sprite();
        this.addChild(this._spineContainer);
        this._spineContainer.position.set(360, 360);
        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick(true));
        this._button.pivot.set(this._button.width * 0.5, 0);
        this._button.enable(false);
        this._button.alpha = 0;

        this._countUp = new BasicBitmapCountUp({
            fontName: TheCryptGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 160,
            tint: 0xffffff
        }, 520, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(360, 578);
        this._countUp.stopAt(0);
        this.visible = false;
        this.addChild(this._countUp);
        this.visible = false;

    }

    constructor() {
        super();
        this.name = "WinCapView";
        this.init();
    }

    private onButtonClick(playClickSound: boolean): void {
        TheCryptSoundManager.playSound("capWinEnds");
        const hideWinCapTL: TimelineLite = new TimelineLite();
        hideWinCapTL.add(() => {
            if (this._idleTimeLine) {
                if (this._idleTimeLine.isActive()) {
                    this._idleTimeLine.pause();
                    this._idleTimeLine.kill();
                }
                this._idleTimeLine = null;
            }
            this._button.enable(false);
        });

        hideWinCapTL.add([
            () => {
                TheCrypt.gameViewContainer.removeDimmer();
                TweenLite.to(this, 0.2, {alpha: 0});
                TweenLite.to([this._button, this._countUp], 0.2, {alpha: 0});
                this._clickCallback();
                this._clickCallback = () => {
                };
            }
        ]);

        hideWinCapTL.add(() => {
            TheCryptSoundManager.playAmbientLoop(1000);
            TheCryptSoundManager.stopSoundEffect(TheCryptSoundConfig.WIN_CAP_MUSIC);
            this.visible = false;
            this._spineContainer.removeChildren();
            this._spines!.destroy();
            this._spines = null;
        });
    }

    public onResize(): void {
        if(!this.visible){
            return;
        }
        if(NolimitApplication.isLandscape){
            this._button.position.set(360, 588);
            return;
        }
        this._button.position.set(360, Math.max(530, NolimitApplication.screenBounds.bottom - 210));
    }


    public show(callback: () => void, isReplay: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            totalWin: number = TheCrypt.model.gameData.accumulatedRoundWin;

        tl.add(() => {
            this._clickCallback = callback;
        });

        if (this._spines) {
            this._spines.destroy();
            this._spines = null;
        }

        this._spines = new PIXI.spine.Spine(TheCrypt.assetLoader.getSpineAsset(TheCrypt.isNJServer?"winCapNJ":"winCap"));

        tl.add(() => {
            TheCrypt.keypadPlugin.hide();
            this._countUp.stopAt(0);
            this._countUp.scale.set(0.5, 0.5);
            this._countUp.position.set(360, 578);
            this._countUp.alpha = 1;
            this.visible = true;
            this.onResize();
            this.alpha = 1;
            TheCryptSoundManager.stopAmbientLoop();
            TheCrypt.gameViewContainer.addDimmer(true);
            this._spineContainer.addChild(this._spines!);
            this._spines!.state.setAnimation(0, "eff_loop", true);
        }, 0);

        tl.add(new SpineTween(this._spines!, 1, "A"), 0);
        tl.add([
            () => {
                TheCryptSoundManager.playSound(TheCryptSoundConfig.WIN_CAP_START);
                //TheCryptSoundManager.playCapwinSound();
            },
            TweenLite.to(this._countUp, 0.1, {alpha: 1}),
            TweenLite.to(this._countUp.scale, 0.1, {x: 1, y: 1, ease: "sine.in"}),
            this._countUp.getCountAnimation(0, totalWin, 6.625)
        ], 0);

        tl.add([
            () => {
                this.addChild(this._button);
                TheCryptSoundManager.stopSoundEffect(TheCryptSoundConfig.WIN_CAP_START);
                TheCryptSoundManager.playWinCapMusic();
                this._spines!.state.setAnimation(2, "B", true)
            },
            TweenLite.to(this._button, 0.6, {alpha: 1}),
            TweenLite.to(this._countUp, 0.6, {alpha: 0}),
        ], 6.625+1.6);
        tl.add([
            () => {
                this._button.enable(true);
                TheCrypt.keypadPlugin.setWin(TheCrypt.model.gameData.accumulatedRoundWin, true, TheCryptHelper.isWinBelowStake());
                TheCrypt.collectors.hide();
            }]);

        return tl;
    }
}